import { render, staticRenderFns } from "./LocationSidebar.vue?vue&type=template&id=36930cac&scoped=true&"
import script from "./LocationSidebar.vue?vue&type=script&lang=js&"
export * from "./LocationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LocationSidebar.vue?vue&type=style&index=0&id=36930cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36930cac",
  null
  
)

export default component.exports